<script>
  import { onMount } from 'svelte'
  import { eventApi } from '../../store'
  let apiEvent
  eventApi.subscribe((value) => {
    apiEvent = value
  })
  let list = []
  let gallery = []
  let loc = ''

  onMount(function () {
    let xhttp = new XMLHttpRequest()
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        list = JSON.parse(xhttp.responseText)
      }
    }
    xhttp.open('GET', `${apiEvent}`, true)
    xhttp.send()
  })

  function handleEvent(e) {
    let xhttp = new XMLHttpRequest()
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        loc = e.target.value
        gallery = JSON.parse(xhttp.responseText)
      }
    }
    xhttp.open('GET', `${apiEvent}/?folder=${e.target.value}`, true)
    xhttp.send()
  }

  function galleryNull() {
    gallery = ''
  }
</script>

{#if gallery == ''}
  <div class="contain">
    <h1 class="header text-center">DSAANA Event Gallery</h1>
    <div class="main-card">
      <div class="card" style="width: 18rem;">
        <div class="card-body">
          <h5 class="card-title">Video Events</h5>
          <a href="/videoevent" class="btn btn-danger">View</a>
        </div>
      </div>

      {#each list as folder}
        <div class="card" style="width: 18rem;">
          <div class="card-body">
            <h5 class="card-title">{folder}</h5>
            <button
              on:click="{handleEvent}"
              value="{folder}"
              class="btn btn-primary saffron">View</button>
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}

{#if gallery != ''}
  <div class="container-ds">
    <h1 class="heading">{loc}</h1>

    <div class="text-center">
      <button on:click="{galleryNull}" class="btn btn-primary saffron">
        Go back to Gallery
      </button>
      <br /><br />
    </div>

    <div class="gallery">
      {#each gallery as image}
        <div class="gallery-item">
          <img
            class="gallery-image"
            src="{apiEvent}gallery/{loc}/{image}"
            alt="{loc}-{image}" />
        </div>
      {/each}
    </div>
  </div>
{/if}

<style lang="scss">
  .saffron {
    background-color: #ff9933;
    border-color: #ff9933;

    &:hover {
      background-color: rgb(248, 176, 103);
    }
  }
  .contain {
    width: 90vw;
    margin: auto;
  }
  .main-card {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .card {
      margin: auto 10px;
    }
  }

  @import url(https://fonts.googleapis.com/css?family=Montserrat:500);

  .container-ds {
    max-width: 100rem;
    margin: 0 auto;
    padding: 0 2rem 2rem;
  }

  .heading {
    font-family: 'Montserrat', Arial, sans-serif;
    font-size: 4rem;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    padding: 3.5rem 0;
    color: #1a1a1a;
  }

  .gallery {
    display: flex;
    flex-wrap: wrap;
    /* Compensate for excess margin on outer gallery flex items */
    margin: -1rem -1rem;
  }

  .gallery-item {
    /* Minimum width of 24rem and grow to fit available space */
    flex: 1 0 24rem;
    /* Margin value should be half of grid-gap value as margins on flex items don't collapse */
    margin: 1rem;
    box-shadow: 0.3rem 0.4rem 0.4rem rgba(0, 0, 0, 0.4);
    overflow: hidden;
  }

  .gallery-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 400ms ease-out;
  }

  .gallery-image:hover {
    transform: scale(1.15);
  }

  /*

The following rule will only run if your browser supports CSS grid.

Remove or comment-out the code block below to see how the browser will fall-back to flexbox styling. 

*/

  @supports (display: grid) {
    .gallery {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(24rem, 1fr));
      grid-gap: 2rem;
    }

    .gallery,
    .gallery-item {
      margin: 0;
    }
  }
</style>
